import type { IMasterDataReasonCodeMappingRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataReasonCodeMappingDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataReasonCodeMappingUseCase {
  private readonly repository: IMasterDataReasonCodeMappingRepository;

  constructor(repository: IMasterDataReasonCodeMappingRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataReasonCodeMappingDTO) {
    return this.repository.createReasonCodeMapping(params);
  }
}
